
import React, { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { CATEGORY_LABELS } from "@/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { formatCategoryDisplay } from "@/services/business/categoryService";

interface CategorySelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
}

const CategorySelect: React.FC<CategorySelectProps> = ({
  value,
  onChange,
  error,
  required = false,
}) => {
  // Create a sorted array of categories from CATEGORY_LABELS
  const categories = Object.keys(CATEGORY_LABELS).sort((a, b) => 
    formatCategoryDisplay(a).localeCompare(formatCategoryDisplay(b))
  );

  return (
    <div className="space-y-2">
      <Label htmlFor="category">
        Category {required && "*"}
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className={error ? "border-red-500" : ""}
          id="category"
        >
          <SelectValue placeholder="Select a category" />
        </SelectTrigger>
        <SelectContent>
          {categories.map((category) => (
            <SelectItem key={category} value={category}>
              {formatCategoryDisplay(category)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default CategorySelect;
